import { $, addAction, INIT } from '@situation/setdesign.util';
import { sceneController } from '../../shared/animations/setup';

/* global ScrollMagic */
addAction(INIT, () => {
    $('.text--animated-lead').each((index, element) => {
        const options = { triggerElement: element, triggerHook: 0.75 };
        const scene = new ScrollMagic.Scene({ ...options });
        scene.setClassToggle(element, 'text--animated-lead-active');
        scene.addTo(sceneController);
    });
});
